import React from 'react'
import { useForm } from 'react-hook-form'
import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css'

const Register = () => {
  const { register, handleSubmit, formState: { errors } } = useForm()

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL,
        {
          mobile: data.mobileNumber,
          source: 'WIDGET'
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`
          }
        }
      )

      if (response.data.statusCode === 200) {
        const { status, customerId } = response.data.data
        if (status === 'EXISTS') {
          alert(`Number already registered. Customer ID: ${customerId}`)
        } else {
          alert('Registration successful!')
        }
      }
    } catch (error) {
      console.error('Error registering customer:', error)
      alert('There was an error registering the customer. Please try again.')
    }
  }

  return (
    <div className='register-container'>
      <div className="register-widget">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label htmlFor="mobileNumber">Enter mobile number</label>
            <input
              id="mobileNumber"
              type="tel" placeholder="07xxxxxxxx" autoComplete="off"
              {...register('mobileNumber', {
                required: 'Mobile number is required',
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: 'Invalid mobile number format'
                }
              })}
            />
            {errors.mobileNumber && <p>{errors.mobileNumber.message}</p>}
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  )
}

export default Register
